import React from 'react'
import {graphql} from 'gatsby'
import Hero from '../Hero/Hero'
import Tiles from '../Tiles/Tiles'
import Banner from '../Banner/Banner'
import Grid from '../Grid/Grid'
import Features from '../Features/Features'
import Text from '../Text/Text'
import Intro from '../Intro/Intro'
import PriceTable from '../PriceTable/PriceTable'
import Faq from '../Faq/Faq'
import FreeTrial from '../FreeTrial/FreeTrial'
import OrderForm from '../OrderForm/OrderForm'
import VideoLink from '../VideoLink/VideoLink'
import Image from '../Image/Image'
import SpecialContent from '../SpecialContent/SpecialContent'
import ImageGrid from '../ImageGrid/ImageGrid'
import Carousel from '../Carousel/Carousel'
import Quotes from '../Quotes/Quotes'
import VideoHero from '../VideoHero/VideoHero'
import Cards from '../Cards/Cards'
import MobileBanner from '../MobileBanner/MobileBanner'
import Steps from '../Steps/Steps'
import MobileCampaignForm from '../MobileCampaignForm/MobileCampaignForm'
import MobileCampaignBanner from '../MobileCampaignBanner/MobileCampaignBanner'
import MobileLead from '../MobileLead/MobileLead'
import './Layout.scss'

export default function Layout({id, layout, styles}) {

	let blockStyles = {
		paddingTop: styles.padding.top ? `${styles.padding.top}px` : 0,
		paddingRight: styles.padding.right ? `${styles.padding.right}px` : 0,
		paddingBottom: styles.padding.bottom ? `${styles.padding.bottom}px` : 0,
		paddingLeft: styles.padding.left ? `${styles.padding.left}px` : 0,
	}
	let paddingClass = '';
	if(
		blockStyles.paddingBottom !== 0 ||
		blockStyles.paddingTop !== 0 ||
		blockStyles.paddingLeft !== 0 ||
		blockStyles.paddingRight !== 0
	) {
		paddingClass = 'padded';
	}

	let containerStyles = {
		width: styles.containerSize === 'custom' ? styles.containerWidth : ''
	}

	return(
		<section id={id} style={blockStyles} className={`Block background-${styles.background} ${styles.containerSize === 'special' ? 'special' : ''} ${paddingClass}`}>
			<div className={`Block-container size-${styles.containerSize}`} style={containerStyles}>
				{
					layout.map((item, i) => {
						let key = `${id}_${item.fieldGroupName}_${i}`
						switch(item.fieldGroupName) {
							case 'page_Layout_block_Layout_Hero': {
								return <Hero key={key} {...item} />
							}
							case 'page_Layout_block_Layout_Tiles': {
								return <Tiles id={key} key={key} {...item} />
							}
							case 'page_Layout_block_Layout_Quotes': {
								return <Quotes id={key} key={key} {...item} />
							}
							case 'page_Layout_block_Layout_Banner': {
								return <Banner key={key} {...item} />
							}
							case 'page_Layout_block_Layout_Grid': {
								return <Grid id={key} key={key} {...item} />
							}
							case 'page_Layout_block_Layout_Features': {
								return <Features id={key} key={key} {...item} />
							}
							case 'page_Layout_block_Layout_Text': {
								return <Text key={key} {...item} />
							}
							case 'page_Layout_block_Layout_Intro': {
								return <Intro key={key} {...item} />
							}
							case 'page_Layout_block_Layout_PriceTable': {
								return <PriceTable id={key} key={key} {...item} />
							}
							case 'page_Layout_block_Layout_Faq': {
								return <Faq id={key} key={key} {...item} />
							}
							case 'page_Layout_block_Layout_FreeTrial': {
								return <FreeTrial id={key} key={key} {...item} />
							}
							case 'page_Layout_block_Layout_OrderForm': {
								return <OrderForm id={key} key={key} {...item} />
							}
							case 'page_Layout_block_Layout_VideoLink': {
								return <VideoLink id={key} key={key} {...item} />
							}
							case 'page_Layout_block_Layout_Image': {
								return <Image id={key} key={key} {...item} />
							}
							case 'page_Layout_block_Layout_SpecialContent': {
								return <SpecialContent id={key} key={key} {...item} />
							}
							case 'page_Layout_block_Layout_ImageGrid': {
								return <ImageGrid id={key} key={key} {...item} />
							}
							case 'page_Layout_block_Layout_Carousel': {
								return <Carousel id={key} key={key} {...item} />
							}
							case 'page_Layout_block_Layout_Space': {
								return <div key={key} style={{height: `${item.space}${item.unit}`}} />
							}
							case 'page_Layout_block_Layout_VideoHero': {
								return <VideoHero key={key} {...item} />
							}
							case 'page_Layout_block_Layout_Cards': {
								return <Cards key={key} {...item} />
							}
							case 'page_Layout_block_Layout_MobileBanner': {
								return <MobileBanner key={key} {...item} />
							}
							case 'page_Layout_block_Layout_Steps': {
								return <Steps key={key} {...item} />
							}
							case 'page_Layout_block_Layout_MobileCampaignForm': {
								return <MobileCampaignForm key={key} {...item} />
							}
							case 'page_Layout_block_Layout_MobileCampaignBanner': {
								return <MobileCampaignBanner key={key} {...item} />
							}
							case 'page_Layout_block_Layout_MobileLead': {
								return <MobileLead key={key} {...item} />
							}
							default: {
								return null
							}
						}
					})
				}
			</div>
		</section>
	)
}

export const query = graphql`
	fragment Layout on WpPage_Layout_block_Layout {
		... on WpPage_Layout_block_Layout_Hero {
			...Hero
		}
		... on WpPage_Layout_block_Layout_Grid {
			...Grid
		}
		...on WpPage_Layout_block_Layout_Image {
			...Image
		}
		... on WpPage_Layout_block_Layout_SpecialContent {
			...SpecialContent
		}
		... on WpPage_Layout_block_Layout_Banner {
			...Banner
		}
		... on WpPage_Layout_block_Layout_Tiles {
			...Tiles
		}
		... on WpPage_Layout_block_Layout_Features {
			...Features
		}
		...on WpPage_Layout_block_Layout_ImageGrid {
			...ImageGrid
		}
		...on WpPage_Layout_block_Layout_Quotes {
			...Quotes
		}
		... on WpPage_Layout_block_Layout_Text {
			fieldGroupName
			expandable
			maxWidth
			text
			hiddenText
		}
		... on WpPage_Layout_block_Layout_Intro {
			...Intro
		}
		... on WpPage_Layout_block_Layout_Faq {
			fieldGroupName
			faqType
			questions {
				icon
				question
				answer
			}
		}
		...on WpPage_Layout_block_Layout_VideoLink {
			...VideoLink
		}
		... on WpPage_Layout_block_Layout_Space {
			fieldGroupName
			space
			unit
		}
		... on WpPage_Layout_block_Layout_PriceTable {
			...PriceTable
		}
		... on WpPage_Layout_block_Layout_Carousel{
			...Carousel
		}
		... on WpPage_Layout_block_Layout_FreeTrial {
			fieldGroupName
			textbox
			successText
			button {
				url
				title
				target
			}
			link {
				url
				title
				target
			}
		}
		... on WpPage_Layout_block_Layout_OrderForm{
			fieldGroupName
			successText
		}
		... on WpPage_Layout_block_Layout_VideoHero {
			...VideoHero
		}
		... on WpPage_Layout_block_Layout_Cards {
			...Cards
		}
		... on WpPage_Layout_block_Layout_MobileBanner {
			...MobileBanner
		}
		... on WpPage_Layout_block_Layout_Steps {
			...Steps
		}
		... on WpPage_Layout_block_Layout_MobileCampaignForm {
			...MobileCampaignForm
		}
		... on WpPage_Layout_block_Layout_MobileCampaignBanner {
			...MobileCampaignBanner
		}
		... on WpPage_Layout_block_Layout_MobileLead {
			...MobileLead
		}
	}
`